var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShieldUser = function SvgShieldUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 4 7.631-1.43a2 2 0 0 1 .738 0L20 4v9.283a8.51 8.51 0 0 1-4 7.217l-3.47 2.169a1 1 0 0 1-1.06 0L8 20.5a8.51 8.51 0 0 1-4-7.217V4z",
    fill: "#335EEA",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-5 5.5c.216-2.983 2.368-4.5 4.99-4.5 2.66 0 4.846 1.433 5.009 4.5.006.122 0 .5-.418.5H7.404c-.14 0-.415-.338-.404-.5z",
    fill: "#335EEA",
    opacity: 0.3
  }))));
};

export { SvgShieldUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNNCA0bDcuNjMxLTEuNDNhMiAyIDAgMDEuNzM4IDBMMjAgNHY5LjI4M2E4LjUxIDguNTEgMCAwMS00IDcuMjE3bC0zLjQ3IDIuMTY5YTEgMSAwIDAxLTEuMDYgMEw4IDIwLjVhOC41MSA4LjUxIDAgMDEtNC03LjIxN1Y0eiIgZmlsbD0iIzMzNUVFQSIgb3BhY2l0eT0iLjMiLz48cGF0aCBkPSJNMTIgMTFhMiAyIDAgMTEwLTQgMiAyIDAgMDEwIDR6TTcgMTYuNWMuMjE2LTIuOTgzIDIuMzY4LTQuNSA0Ljk5LTQuNSAyLjY2IDAgNC44NDYgMS40MzMgNS4wMDkgNC41LjAwNi4xMjIgMCAuNS0uNDE4LjVINy40MDRjLS4xNCAwLS40MTUtLjMzOC0uNDA0LS41eiIgZmlsbD0iIzMzNUVFQSIgb3BhY2l0eT0iLjMiLz48L2c+PC9zdmc+";